<template>
  <div class="staff-manage">
    <div class="app-panel blank-h">
      <div class="app-control app-table-control">
        <div class="right-region">
          <el-input placeholder="请输入员工姓名或电话" v-model="search.value" clearable></el-input>
          <el-button type="primary" @click="searchParams">搜索</el-button>
          <el-button @click="resetParams">重置</el-button>
        </div>
      </div>
      <el-table :data="datas" v-loading="loading">
        <el-table-column label="照片">
          <template slot-scope="{row}">
            <div class="imgs-wrap">
              <el-image :src="row.face_data.attachment_access_url" :preview-src-list="[row.face_data.attachment_access_url]"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="attr_data.user_attr_name"></el-table-column>
        <el-table-column label="手机号码" prop="attr_data.user_attr_phone"></el-table-column>
        <el-table-column label="部门" prop="attr_data.user_attr_department"></el-table-column>
        <el-table-column label="职位" prop="attr_data.user_attr_title"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="scan(row.attr_data.user_id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    </div>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center size="80%" append-to-body>
      <staff-information :staffId="dialog.id" v-if="dialog.show"></staff-information>
    </el-drawer>
  </div>
</template>

<script>
  import StaffService from '@/io/staff.js';
  import StaffInformation from '@/views/StaffInformation.vue';

  export default {
    name: 'StaffManage',
    data() {
      return {
        dialog: {
          show: false,
          title: '员工详情',
          id: null
        },
        search: {
          value: ''
        },
        datas: [],
        selectDatas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    components: {
      StaffInformation
    },
    mounted () {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        StaffService.listPage(
          this.search.value,
          this.page.currentPage
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data;
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      handleSelectionChange(val) {
        this.selectDatas = val;
      },
      scan(id) {
        this.dialog.show = true;
        this.dialog.id = id;
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .staff-manage {
    .app-panel {
      &:nth-of-type(2) {
        padding-top: 4px;
      }
    }
  }
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>